import Modal from 'components/CncUI/Modal';
import Button from 'components/CncUI/Button';

const LimitModal = props => {
  const { show, onClose } = props;

  return (
    <Modal open={show} maxWidth={400}>
      <Modal.Title>Maximum banks connected</Modal.Title>
      <Modal.Content>
        <Modal.ContentText>
          If you'd like to add another bank, please remove at least one existing
          bank. Active direct deposit will still work even if its bank has been
          disconnected.
        </Modal.ContentText>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>Ok</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default LimitModal;
